import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';
import { TuiDialogContext, TuiDialogOptions } from '@taiga-ui/core';
import { injectContext } from '@taiga-ui/polymorpheus';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export abstract class BaseDialogComponent<InputDataType, OutputDataType> extends BaseResizableComponent {
  private readonly context = injectContext<TuiDialogContext<OutputDataType | void, InputDataType>>();

  get data(): TuiDialogOptions<InputDataType>['data'] | undefined {
    return this.context.data;
  }

  protected cancel(data: OutputDataType) {
    return this.innerCancel(data);
  }

  private innerCancel(data: OutputDataType) {
    this.context.completeWith(data);
  }

  protected apply(data: OutputDataType) {
    return this.innerApply(data);
  }

  private innerApply(data: OutputDataType) {
    this.context.completeWith(data);
  }
}
